import { defineStore } from "pinia";

export type MenuWarning = {
  menuItem: MenuItemType;
  count: number;
};

export const useMenuStore = defineStore("menu", () => {
  const warnings = ref<MenuWarning[]>([]);

  const setWarnings = function (w: MenuWarning[]) {
    warnings.value = [...warnings.value, ...w];
  };

  const clearWarnings = function () {
    warnings.value = [];
  };

  return { warnings, setWarnings, clearWarnings };
});
